import { client, gql } from 'data-provider';
import { IInvoiceHeader, IInvoiceProfile } from 'utilities/invoice-profile';

const invoiceProfileFields = `
  id
  label
  companyName
  companyEmail
  companyNumber
  companyWebsite
  companyBinNo
  companyVatNo
  address
  logoUrl
  isDefault
`;

export interface IInvoiceProfileInput {
  label: string;
  companyName?: string;
  companyEmail?: string;
  companyNumber?: string;
  companyWebsite?: string;
  companyBinNo?: string;
  companyVatNo?: string;
  address?: string;
  logo?: { base64String: string };
  removeLogo?: boolean;
  isDefault?: boolean;
}

export const getInvoiceProfiles = async () => {
  const query = gql`
    query {
      invoiceProfiles {
        ${invoiceProfileFields}
      }
    }
  `;
  const data = await client.request(query);
  return data.invoiceProfiles as IInvoiceProfile[];
};

export const createInvoiceProfile = async (input: IInvoiceProfileInput) => {
  const mutation = gql`
    mutation ($input: InvoiceProfileInput!) {
      createInvoiceProfile(input: $input) {
        ${invoiceProfileFields}
      }
    }
  `;
  const data = await client.request(mutation, { input });
  return data.createInvoiceProfile as IInvoiceProfile;
};

export const updateInvoiceProfile = async (id: string, input: IInvoiceProfileInput) => {
  const mutation = gql`
    mutation ($input: UpdateInvoiceProfileInput!) {
      updateInvoiceProfile(input: $input) {
        ${invoiceProfileFields}
      }
    }
  `;
  const data = await client.request(mutation, { input: { ...input, id } });
  return data.updateInvoiceProfile as IInvoiceProfile;
};

export const deleteInvoiceProfile = async (id: string) => {
  const mutation = gql`
    mutation ($id: ID!) {
      deleteInvoiceProfile(id: $id)
    }
  `;
  await client.request(mutation, { id });
};

// The header to print: a saved sale's stored profile, or a chosen profile before the sale exists.
export const getInvoiceHeader = async (target: { saleId?: string; invoiceProfileId?: string }) => {
  const query = gql`
    query ($saleId: ID, $invoiceProfileId: ID) {
      invoiceHeader(saleId: $saleId, invoiceProfileId: $invoiceProfileId) {
        companyName
        companyEmail
        companyNumber
        companyWebsite
        companyBinNo
        companyVatNo
        address
        image
      }
    }
  `;
  const data = await client.request(query, target);
  return data.invoiceHeader as IInvoiceHeader;
};
